// فایل: @/components/GoogleButton.tsx

"use client";

import { useGoogleLogin } from '@react-oauth/google';
import { useAuth } from '@/context/AuthContext';
import { Loader2 } from 'lucide-react';
import React from 'react';

// کامپوننت آیکون گوگل بدون تغییر باقی می‌ماند
export const GoogleIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48"
        width="24px"
        height="24px"
    >
        <path fill="#FFC107" d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12s5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24s8.955,20,20,20s20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z" />
        <path fill="#FF3D00" d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z" />
        <path fill="#4CAF50" d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.222,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z" />
        <path fill="#1976D2" d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571l6.19,5.238C42.022,35.244,44,30.036,44,24C44,22.659,43.862,21.35,43.611,20.083z" />
    </svg>
);

// ✅ تعریف پراپرتی‌ها برای کامپوننت دکمه
interface GoogleLoginButtonProps {
    isGoogleLoading: boolean;
    setIsGoogleLoading: (loading: boolean) => void;
}

export const GoogleLoginButton = ({ isGoogleLoading, setIsGoogleLoading }: GoogleLoginButtonProps) => {
    // ✅ دیگر از isLoading عمومی context استفاده نمی‌کنیم
    const { loginWithGoogle } = useAuth();

    const handleGoogleApiLogin = useGoogleLogin({
        onSuccess: (tokenResponse) => {
            // ✅ پس از دریافت توکن، تابع اصلی context را صدا می‌زنیم
            // تابع loginWithGoogle خودش در نهایت صفحه را ریدایرکت می‌کند
            loginWithGoogle(tokenResponse.access_token);
        },
        onError: (error) => {
            console.error('Google Login Failed:', error);
            // ✅ در صورت خطا، حالت لودینگ را غیرفعال می‌کنیم
            setIsGoogleLoading(false);
            // toast.error("ورود با گوگل با مشکل مواجه شد.");
        },
    });

    // ✅ یک تابع جدید برای مدیریت کلیک
    const handleClick = () => {
        // ۱. ابتدا حالت لودینگ را در صفحه والد فعال می‌کنیم
        setIsGoogleLoading(true);
        // ۲. سپس فرآیند ورود گوگل را آغاز می‌کنیم
        handleGoogleApiLogin();
    }

    return (
        <button
            type="button"
            onClick={handleClick}
            // ✅ دکمه بر اساس استیت پاس داده شده غیرفعال می‌شود
            disabled={isGoogleLoading}
            className="
                w-full flex items-center justify-center gap-3
                px-4 py-3 text-base font-semibold text-zinc-700 dark:text-zinc-200
                bg-white dark:bg-zinc-800
                border border-zinc-300 dark:border-zinc-600
                rounded-lg shadow-sm
                hover:bg-zinc-50 dark:hover:bg-zinc-700
                focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500
                transition-colors duration-200
                disabled:opacity-60 disabled:cursor-not-allowed
            "
        >
            {/* ✅ لودر بر اساس استیت پاس داده شده نمایش داده می‌شود */}
            {isGoogleLoading ? (
                <Loader2 className="h-5 w-5 animate-spin" />
            ) : (
                <GoogleIcon />
            )}
            <span>ورود با حساب گوگل</span>
        </button>
    );
};